import { Validator } from '@vista-digital/validator';
import { areaCategorySeatSelectionLimitsValidator } from './area-category-seat-selection-limits';
export const seatSelectionLimitsValidator = Validator.object({
    min: Validator.number({ min: 0 }),
    max: Validator.number({ min: 1 }),
    limitsPerAreaCategory: Validator.optional(areaCategorySeatSelectionLimitsValidator)
});
